// The Salesforce connect flow finishes in a separate tab on one of the result pages.
// Those pages post here so an open Admin > Integrations tab can refresh its state straight away.
const SALESFORCE_CONNECTION_CHANNEL = 'salesforce-connection';

const isSupported = () => typeof BroadcastChannel !== 'undefined';

export const notifySalesforceConnection = success => {
    if (!isSupported()) return;
    const channel = new BroadcastChannel(SALESFORCE_CONNECTION_CHANNEL);
    channel.postMessage({ success });
    channel.close();
};

export const listenForSalesforceConnection = onResult => {
    if (!isSupported()) return () => {};
    const channel = new BroadcastChannel(SALESFORCE_CONNECTION_CHANNEL);
    channel.onmessage = event => onResult(event.data);
    return () => channel.close();
};
